export default __webpack_public_path__ + "static/media/6S.33eb8c1b.svg";